module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n	.width-regulator td:nth-child(1) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(2) {\n		width: 60%;\n	}\n\n	.width-regulator td:nth-child(3) {\n		width: 30%;\n	}\n</style>\n\n<table class=\"w100 gl-report__table width-regulator\">\n	<thead>\n	<tr>\n		<td>TODO</td>\n		<td>TODO</td>\n		<td>TODO</td>\n	</tr>\n	</thead>\n</table>\n\n<div class=\"wh100\">\n	<div class=\"cell__abs_container\">\n		<div class=\"cell__abs overflow-y__auto\">\n\n			<table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n				<tr>\n					<td>TODO</td>\n					<td>TODO</td>\n					<td>TODO</td>\n				</tr>\n			</table>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}